module.exports = __webpack_public_path__ + "media/images/icons/outlined/weibo-circle-b91cec9a922da8687c86b363b624d078.svg";